/**
 * Supported conversation panel views in Communications.
 */
export const COMMUNICATIONS_VIEWS = ['cards', 'pipeline', 'table'] as const;

/**
 * URL view modes supported by the Communications page.
 */
export type CommunicationsView = (typeof COMMUNICATIONS_VIEWS)[number];
